import { DateTime } from "luxon";

/**
 * Calculates an array of months from a range of luxon date time objects.
 * Each month has start and end iso dates.
 */
export function getMonthsFromRange(startDate, endDate) {
  if (!DateTime.isDateTime(startDate) || !DateTime.isDateTime(endDate)) {
    return [];
  }

  const months = [];
  let monthlyStartDate = startDate.startOf("month");

  while (monthlyStartDate <= endDate) {
    const startDateIso = monthlyStartDate.toISODate();
    const endDateIso = monthlyStartDate.endOf("month").toISODate();
    months.push({ startDate: startDateIso, endDate: endDateIso });
    monthlyStartDate = monthlyStartDate.plus({ months: 1 });
  }

  return months;
}
